<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { ref, onMounted } from 'vue';
// import i18n from '@/localization/i18n';
import { useBusinessRequestFormStore } from '../stores/business-request-form-store';

const businessRequestFormStore = useBusinessRequestFormStore()
const { titleFormData, isFromArticles } = storeToRefs(businessRequestFormStore)

import { logNewEvent } from '@/services/modules/firebase';

// const t = i18n.global.t
const dropdownVisible = ref(false);
const items = [
    "Rénovation intérieure", "Rénovation extérieure, ravalement, mousse",
    "Installation, pose, aménagement, entretien", "Peintre, peinture, enduit, papier peint",
    "Plombier, plomberie, robinetterie, fuite", "Salle de bain, douche, wc, lavabo, baignoire",
    "Electricien, électricité, interrupteur", "Maçon, maçonnerie, terrassement",
    "Charpentier, charpente, étanchéité", "Couvreur, couverture, toiture, tuile, gouttière",
    "Chauffagiste, chauffage, chaudière, radiateur, isolation", "Fenêtre, porte, store, volet",
    "Serrurier, serrure", "Menuisier, menuiserie",
    "Revêtement, sol, mur, plafond", "Carreleur, carrelage",
    "Jardinier, jardin, élagueur, élagage", "Architecte",
    "Décorateur, décoratrice, décoration", "Plaquiste, placo, parquet",
    "Plâtrier, plâtre", "Climatiseur, climatisation",
    "Démolition, évacuation, gravat",
];

const filteredItems = ref([...items]);

const showDropdown = () => {
    dropdownVisible.value = true;
};

const hideDropdown = () => {
    dropdownVisible.value = false;
};

const filterItems = () => {
    const query = titleFormData.value.title.toLowerCase();
    filteredItems.value = items.filter(item => item.toLowerCase().includes(query));
};


const selectItem = (item: string) => {
    titleFormData.value.title = item;
    hideDropdown();
};


onMounted(() => {
    document.addEventListener('click', (e: Event) => {
        const target = e.target as HTMLElement;
        if (!target.closest('.dropdown-container')) {
            hideDropdown();
        }
    });

    if (isFromArticles.value) {
        setTimeout(() => {
            businessRequestFormStore.isFromArticles = false
            postRequest()
        }, 200);
    }
});

const postRequest = () => {
    businessRequestFormStore.current_context = "presentation"
    logNewEvent("presta_request_pop_up_open")
    const requestPostButton = document.getElementById("requestPostButton")
    if (requestPostButton) {
        requestPostButton.click()
    }
}


const staticText = "Je cherche un ";
const professions = [
    "installateur électroménager",
    "chauffagiste",
    "plombier",
    "électricien",
    "technicien polyvalent",
    "peintre",
    "plaquiste",
    "monteur de meubles",
    "maçon",
    "menuisier",
    "couvreur",
    "carreleur",
    "jardinier",
    "vitrier"
];

const animatedPlaceholder = ref('');
let professionIndex = 0;
let charIndex = 0;

const typeText = () => {
    const currentProfession = professions[professionIndex];

    if (charIndex <= currentProfession.length) {
        // Affichage de la partie statique + caractères progressivement
        animatedPlaceholder.value = staticText + currentProfession.slice(0, charIndex) + '█';
        charIndex++;

        setTimeout(typeText, 100);
    } else {
        // Pause à la fin du mot
        setTimeout(() => {
            // Réinitialisation pour mot suivant
            charIndex = 0;
            professionIndex = (professionIndex + 1) % professions.length;
            typeText();
        }, 1000); // Délai de pause entre deux mots
    }
};
const isFocused = ref(false);

onMounted(() => {
    typeText();
});

</script>

<template>
    <div class="dropdown-container my-4">
        <div class="dropdown-input-wrapper bg-white border rounded-5" style="padding: 10px;">

            <input type="text" v-model="titleFormData.title" @focus="isFocused = true; showDropdown()"
                @blur="isFocused = false" @input="filterItems" :maxlength="64"
                class="dropdown-input rounded-3 form-control text-start mb-0 input-block-field border-0 btn-text-visibility"
                style="box-shadow: none !important;" :placeholder="isFocused ? '' : animatedPlaceholder" />
            <button class="btn btn-primary rounded-5 input-block-btn me-2 d-flex" @click="postRequest" type="button">
                <span class="material-symbols-outlined" style="font-size: 20px; color: #fff;">search</span>
            </button>
            <!-- g_frm_home_business_request_input_pl -->
        </div>
        <div v-show="dropdownVisible" class="dropdown-list mt-0" style="position: absolute;"
            v-if="filteredItems.length !== 0">
            <div v-for="(item, index) in filteredItems" :key="index" class="item" @click="selectItem(item)">
                <h4 class="item-text mb-0">
                    {{ item }}
                </h4>
            </div>
        </div>
    </div>
</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended.css');
@import url('@/assets/css/animate.css');
@import url('@/assets/css/main.css');
@import url('@/assets/css/responsive.css');

.btn-text-visibility {
    font-size: 16px !important;
    font-weight: normal !important;
}

.form-control:focus {
    border-color: #FEB23C;
    box-shadow: 0 0 0 0.02rem #FEB23C;
}

.form-control::placeholder {
    color: #b9b9c3;
    opacity: 1;
}

.dropdown-container {
    position: relative;
    width: auto;
    z-index: 100 !important;
}

.dropdown-input-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    padding-top: 10px;
    padding-bottom: 10px;
}

.input-block-btn {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}

.input-block-field {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
}

.dropdown-input {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #d0d0d0;
    border-radius: 5px 0 0 5px;
    font-size: 14px;
    outline: none;
}

.dropdown-input::placeholder {
    color: #233648;
    opacity: 1;
    font-weight: 700;
    font-size: 18px;

}

.dropdown-list {
    position: absolute;
    top: 15;
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid #d0d0d0;
    overflow-y: auto;
    display: block;
    z-index: 20000;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-height: 300px;
    padding-top: 5px;
    padding-bottom: 5px;
}

.dropdown-header {
    padding: 5px 10px;
    font-weight: bold;
    background: white;
    border-bottom: 1px solid #d0d0d0;
    font-size: 14px;
}

.item {
    padding: 8px 10px;
    cursor: pointer;
    font-size: 14px;
}

.item:hover {
    background-color: #eee;
}

.btn-primary:focus {
    background-color: #FEB23C !important;
}

.item-text {
    font-size: 13px;
    color: #4A4E56;
    font-weight: normal;
    font-family: "Century Gothic", sans-serif !important;
}


/* @media (max-width: 768px) {

    .dropdown-container {
        width: 90%;
    }
}


@media (min-width: 768px) {

    .dropdown-container {
        width: 40%;
    }
} */
</style>
